import isEmpty from 'lodash/isEmpty';

const extension = {
    jpeg: ['jpg', 'jpeg'],
    png: 'png',
};

export function replaceExtension(filename, newExtension) {
    const parts = filename.split('.');
    if (parts.length > 1) {
        const ext = parts[parts.length - 1];
        const foundExt = Object.keys(extension).find(key => {
            const exts = extension[key];
            if (Array.isArray(exts)) {
                return !isEmpty(exts.find(e => e === ext));
            }
            return ext === exts;
        });
        if (!foundExt) {
            return `${filename}.${newExtension}`;
        }
        parts.splice(-1, 1);
        return `${parts.join('.')}.${newExtension}`;
    }
    return `${filename}.${newExtension}`;
}

export function bytesToSize(bytes) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) {
        return '0 Byte';
    }
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return `${Math.round(bytes / Math.pow(1024, i) * 10) / 10} ${sizes[i]}`;
}
